import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CMS } from '../../utils/CMS';
import { TripType } from '../../models';
import { ConnectedFlightsManager } from './FlightsManager';
import { SegmentManagerDesktop } from './Segment/SegmentManager/SegmentManagerDesktop';
import { TripTypeSelectorDesktop } from '../TripTypeSelector/TripTypeSelectorDesktop';
import { FlightClassSelector } from '../FlightClassSelector/FlightClassSelectorDesktop';
import CalendarContextProvider from './CalendarContext';
import { ConnectedDirectFlightSelector } from '../DirectFlightSelector';
import { AddSegmentDesktop } from './Segment/AddSegment/AddSegmentDesktop';
import { ResidentDiscount } from '../ResidentDiscount/ResidentDiscountDesktop';
import { SearchButtonStyled } from '../SearchButton/SearchButtonStyled';
import { AirlineFilterSelector } from '../AirlineFilterSelector/AirlineFilterSelector';
import { ABUtils } from '../../utils';
import { FlightsManagerDesktopEl } from './FlightsManagerDesktop.style';
import { ConnectedFaresTrackingCalculator } from '../../components/Calendar/Context/FaresTrackingCalculator';
import { prefetchAssets } from '../../utils/PrefetchUtils';
import { CarsSearchExtension } from '../CarsSearchExtension';

export const FlightsManagerDesktop = ({ isHotelOptionEnabled, rootDataAttr, isRailsSearcher }) => (
    <ConnectedFlightsManager
        rootDataAttr={rootDataAttr}
        // eslint-disable-next-line complexity
        render={({ tripType }) => {
            prefetchAssets();
            const isRoundTrip = tripType === TripType.ROUND_TRIP;
            const displayDPButton = isHotelOptionEnabled && isRoundTrip;
            const { airlinefilteriata: airlineIata, airlinefiltername: airlineName } = rootDataAttr;
            const ctaClassName = classNames({
                'odf-space-inner-right-xl': !isRoundTrip,
                'FlightsManagerFooterCTA': true,
            });
            const { isAbTrain, isStreamSearch, isCssVariationMobile } = ABUtils.getABs();
            const searchDpKeyId = isAbTrain
                ? 'flightsManager.searchDynpack.TRAINS'
                : 'flightsManager.searchDynpack.main';
            const searchKeyId = isAbTrain || isRailsSearcher
                ? 'flightsManager.search.TRAINS'
                : 'flightsManager.search.main';
            const flightClassSelectorClass = isCssVariationMobile ? 'odf-space-outer-top-xs' : '';
            const flightsSearchEventId = isStreamSearch
                ? 'flights-search-streaming'
                : 'flights-search';

            return (
                <FlightsManagerDesktopEl className="FlightsManager odf-box odf-space-inner-m">
                    <div className="odf-row-float odf-row-nogutter">
                        <div className="odf-col odf-stroke-primary-right odf-space-outer-right-m">
                            <TripTypeSelectorDesktop isRailsSearcher={isRailsSearcher} />
                        </div>
                        {!isRailsSearcher && (
                            <div
                                className={`odf-col odf-stroke-primary-right odf-space-outer-right-m ${flightClassSelectorClass}`}
                            >
                                <FlightClassSelector />
                            </div>
                        )}
                        <div className="odf-col">
                            <ConnectedDirectFlightSelector isRailsSearcher={isRailsSearcher} />
                        </div>
                    </div>
                    <div className="odf-space-inner-top-m">
                        <CalendarContextProvider>
                            <SegmentManagerDesktop />
                        </CalendarContextProvider>
                    </div>

                    <div className="FlightsManagerFooter">
                        <div className="FlightsManagerFooterLeft">
                            {!isRailsSearcher && (<AddSegmentDesktop />)}
                            {airlineIata && airlineName && (
                                <div className="FlightsManagerAirline">
                                    <div className="odf-space-inner-top-s">
                                        <AirlineFilterSelector
                                            airlineIata={airlineIata}
                                            airlineName={airlineName}
                                        />
                                    </div>
                                </div>
                            )}

                            {(tripType === TripType.ONE_WAY ||
                                tripType === TripType.ROUND_TRIP) && (
                                <div>
                                    <CarsSearchExtension tab="flights" />
                                </div>
                            )}
                            {!isRailsSearcher && (
                                <div className="FlightsManagerResidents">
                                    <ResidentDiscount />
                                </div>
                            )}
                        </div>

                        <div className={ctaClassName}>
                            {displayDPButton && (
                                <div className="odf-space-inner-right-s">
                                    <SearchButtonStyled
                                        version="secondary"
                                        testId="search-dp-btn"
                                        htmlEventID="flights-dp-search"
                                        dynPack
                                    >
                                        <CMS id={searchDpKeyId} />
                                    </SearchButtonStyled>
                                </div>
                            )}
                            <ConnectedFaresTrackingCalculator>
                                {({ extraTracking }) => (
                                    <SearchButtonStyled
                                        extraTracking={extraTracking}
                                        testId="search-flights-btn"
                                        htmlEventID={flightsSearchEventId}
                                    >
                                        <CMS id={searchKeyId} />
                                    </SearchButtonStyled>
                                )}
                            </ConnectedFaresTrackingCalculator>
                        </div>
                    </div>
                </FlightsManagerDesktopEl>
            );
        }}
    />
);

FlightsManagerDesktop.propTypes = {
    isHotelOptionEnabled: PropTypes.bool,
};

FlightsManagerDesktop.defaultProps = {
    isHotelOptionEnabled: true,
    rootDataAttr: {
        airlinefilteriata: null,
        airlinefiltername: null,
    },
};
